import styles from "./style.module.scss";
import NotFoundTextImage from "src/assets/not-found-text.png";
import TakoImage from "src/assets/tako.png";
import WaveImage from "src/assets/wave.png";

const NotFound = () => {
  return (
    <>
      <title>石巻マリンヴィレッジ | NOTFOUND</title>
      <article className={styles.container}>
        <img src={WaveImage} alt="Wave" className={styles.wave} />
        <div className={styles.innerBox}>
          <img src={TakoImage} alt="Tako" className={styles.tako} />
          <img
            src={NotFoundTextImage}
            alt="Not Found"
            className={styles.notFound}
          />
        </div>
      </article>
    </>
  );
};

export default NotFound;
